import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SecureTheirFuture from "./sections/SecureTheirFuture";
import OurStoryAndMission from "./sections/OurStoryAndMission";
import SpecializedCareWings from "./sections/SpecializedCareWings";
import OurImpactInNumbers from "./sections/OurImpactInNumbers";
import VoicesOfHowardCounty from "./sections/VoicesOfHowardCounty";
import FindTheLab from "./sections/FindTheLab";
import LatestCampusUpdates from "./sections/LatestCampusUpdates";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SecureTheirFuture />
      <OurStoryAndMission />
      <SpecializedCareWings />
      <OurImpactInNumbers />
      <VoicesOfHowardCounty />
      <FindTheLab />
      <LatestCampusUpdates />
      <Footer />
    </div>;
}